<div class="portfolio-box fees">
  <h2 class="ui-headline">{{ 'new_strategy.portfolio_screen.graph_box.costs.title' | translate }}</h2>
  <div class="fees-number">
    <div>
      <p>{{ 'new_strategy.portfolio_screen.graph_box.costs.annual-3a' | translate }}</p>
      <p class="big">{{ annualFee | translatePercent: language }}</p>
      <p class="subtitle" *ngIf="showCostNote">{{ 'new_strategy.portfolio_screen.graph_box.costs.note-3a' | translate }}</p>
    </div>
  </div>
  <div class="fees-covering">
    <p>{{ 'new_strategy.portfolio_screen.graph_box.costs.note2-3a' | translate }}</p>
    <div class="fees-icons">
      <div class="fees-icons-icon" *ngFor="let icon of iconArray">
        <img [src]="'/assets/images/' + icon + '.svg'" />
        <p [innerHtml]="'new_strategy.portfolio_screen.graph_box.costs.' + icon + '-3a' | translate"></p>
      </div>
    </div>
  </div>
  <div class="fees-details">
    <p *ngIf="!showMore" class="show-more" (click)="toggleShowMore(true)">{{ 'strategy.show_more' | translate }}</p>
    <ng-container *ngIf="showMore">
      <p class="show-more" (click)="toggleShowMore(false)">{{ 'strategy.show_less' | translate }}</p>
      <div class="fees-items">
        <h4 class="ui-headline">{{ 'new_strategy.portfolio_screen.graph_box.costs.details-3a.title' | translate }}</h4>
        <div *ngFor="let item of feesDetails" class="fees-items-item">
          <p>{{ item.title | translate }}</p>
          <p>{{ item.fees }}</p>
        </div>
      </div>
      <div class="legal">
        <p class="ui-caption">{{ 'new_strategy.portfolio_screen.graph_box.costs.disclaimer1-3a' | translate }}</p>
        <p class="ui-caption">{{ 'new_strategy.portfolio_screen.graph_box.costs.disclaimer2-3a' | translate }}</p>
      </div>
    </ng-container>
  </div>
</div>
